<template>
	<div>
		<Container>
			<TopBar />
			<div class="content">
				<div class="search">
					<p class='bogo_tips' v-if='bogo_switch_tip' v-html="bogo_switch_tip"></p>

					<Form class='search-form' ref="formInline" :model="search" inline style='text-align: center;'>
						<FormItem prop="beginTime">
							<DatePicker size='large' type="date" v-model='search.beginTime' placement="bottom-end" placeholder="开始日期(Choose Date)"  @keyup.enter.native='searchOrders'></DatePicker>
						</FormItem>
						<FormItem>
							<span>至</span>
						</FormItem>
						<FormItem prop="endTime">
							<DatePicker size='large' type="date" v-model='search.endTime' placement="bottom-end" placeholder="结束日期(Choose Date)"  @keyup.enter.native='searchOrders'></DatePicker>
						</FormItem>
						<FormItem>
							<Button size='large' :loading='btnloading' type="primary"  @click='searchOrders'>搜索(Search)</Button>
						</FormItem>
					</Form>
				</div>
				<Tabs v-model="paymentStatus" style="display: flex;overflow-x: auto; white-space: nowrap;">
					<TabPane label="已付款(Paid)" name="Pay"></TabPane>
					<Badge :count="UnPayCount" :offset="showMerge ? [10,420] : [10, 175]" type="primary">
						<TabPane label="未付款(UnPay)" name="UnPay"></TabPane>
					</Badge>
			        <TabPane label="售后(After sales)" name="Return"></TabPane>
			        <TabPane v-if='showMerge' label="待合并发货(To be consolidated)" name="-2"></TabPane>
			    </Tabs>
				<!-- <omsOrders ref='omsOrders' :beginTime='search.beginTime' :endTime='search.endTime' v-show='paymentStatus == "All"'/> -->
			    	<Table ref='selection' class='orderTable' :loading="loading" stripe :columns="columns" :data="orders" @on-selection-change='selection'></Table>
					<div class='xs-cells' v-for='order in orders'>
						<Row class='xs-cells-item' style='margin-top: 0.2rem;'>
							<Col span='12'>订单日期(Order Date)</Col>
							<Col span='12' style='text-align: center;'>{{order.CreateTime.substr(0,19).replace('T',' ')}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>订单编号(Order Number)</Col>
							<Col span='12' style='text-align: center;'>{{order.OrderNo}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>订单金额/PV(Order Amount/PV)</Col>
							<Col span='12' style='text-align: center;'>{{order.TotalPaid}}&nbsp;/&nbsp;{{order.PValue}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>订单渠道(Order Channel)</Col>
							<Col span='12' style='text-align: center;'>{{order.Channel}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>合并订单号(Consolidated order number)</Col>
							<Col span='12' style='text-align: center;text-decoration :underline;color:#B176C5;font-size:0.13rem'><span @click='goMergeOrders(order)'>{{order.MergeOrderNo}}</span></Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>订单状态(Order Status)</Col>
							<Col span='12' style='text-align: center;' v-html='typePlay(order)'></Col>
						</Row>
						<Row class='xs-cells-item' v-if="paymentStatus == 'Return'">
							<Col span='12'>退换货单号(ApplyNo)</Col>
							<Col span='12' style='text-align: center;'>{{order.ApplyNo}}</Col>
						</Row>
						<Row class='xs-cells-item' v-if="paymentStatus == 'Return'">
							<Col span='12'>退换货类型(returnType)</Col>
							<Col span='12' style='text-align: center;'>{{order.returnTypeCode}}</Col>
						</Row>
						<div class='flex-line'>
							<div span='6' style='text-align: right'><Button :style='{color:disabledExchange(order)?"#ccc":"#B176C5"}' type='text' @click='exchangeSales(order)' :disabled='disabledExchange(order)' v-html='exchangeTitle(order.orderReplaceStatus)'></Button></div>
							<div span='6' style='text-align: right'><Button :style='{color:disabledReturn(order)?"#ccc":"#B176C5"}' type='text' @click='returnSales(order)' :disabled='disabledReturn(order)' v-html='returnTitle(order.orderCancelStatus)'></Button></div>
							<div span='6' style='text-align: right'>
								<Button v-if='canRepay(order)' style='color:#B176C5;' type='text' @click='qxpay(order.OrderNo)'>取消</Button>
								<Button v-else-if='canCancelPaid(order)' style='color:#B176C5;' type='text' @click='cancelOrder(order)'>取消</Button>
							</div>
							<div span='6' style='text-align: right'><Button v-if='canRepay(order)' style='color:#B176C5;' type='text' @click='gotoPay(order.OrderNo)'>继续付款</Button></div>
							<div span='6' style='text-align: right'><Button style='color:#B176C5;' type='text' @click='showDetail(order)'>查看</Button></div>
						</div>
					</div>
					<div class="tip">
						<p v-if='paymentStatus == "Pay" && hasMergingOrders' v-html='tipForPay'></p>
						<div v-else-if='paymentStatus == "-2" && hasMergingOrders' v-html='tipForMerge'></div>
					</div>
					<div class="page" v-if='paymentStatus == "-2"'>
						<Button @click='goMergeOrders()' v-if='orders.length' type='primary'>合并发货(Combined shipment)</Button>
					</div>
					
					<div class="page" v-else>
						<Button @click='loadData(0)' :disabled='page==0' class='goon-btn' size='large' type='primary'>上一页(Last Page)</Button>
						&nbsp;
						<Button @click='loadData(1)' :disabled='nextBtn' class='goon-btn' size='large' type='primary'>下一页(Next Page)</Button>
					</div>
			</div>
		</Container>
		<transition mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import omsOrders from "./omsOrders";
import util from "@/config/util";
import {cvoUrl} from '@/config/env'
import { api_methods } from "@/service/loadData";
const now = new Date()
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
	data() {
		return {
			paymentStatus:'Pay',
			fromPath: null,
			loading: true,
			btnloading: false,
			reload: false,
			showMerge:false,
			search: {
				orderNo: null,
				channel: null,
				beginTime:new Date(now.getFullYear(),now.getMonth(),now.getDate() - 30),
				endTime: now,
				time: null,
				orderStatus: null,
				PageIndex: 0,
				PageSize: 20
			},
			o_columns: [
				{
					key: "CreateTime",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "订单日期"),
							h("div", null, "Order Date")
						]);
					},
					render: (h, params) => {
						let innerHtml = params.row.CreateTime.substr(
							0,
							19
						).replace("T", " ");
						return h("div", null, innerHtml);
					}
				},
				{
					key: "OrderNo",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "订单编号"),
							h("div", null, "Order Number")
						]);
					},
					render: (h, params) => {
						let forOrder = this.forOrder(params.row);
						return h("div", [
							h("div", null, params.row.OrderNo),
							h("p", { style: { color: "#3484e0" } }, forOrder)
						]);
					}
				},
				{
					key: "total",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "订单金额/PV"),
							h("div", null, "Order Amount/PV")
						]);
					},
					render: (h, params) => {
						let innerHtml = `￥${params.row.TotalPaid} / ${params.row.PValue}`;
						return h("div", null, innerHtml);
					}
				},
				{
					key: "Channel",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "订单渠道"),
							h("div", null, "Order Channel")
						]);
					}
				},{
					key: "MergeOrderNo",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "合并订单号"),
							h("div", null, "Consolidated order number")
						]);
					},
					render:(h,params)=>{
						let no = params.row.MergeOrderNo
						if (no) {
							return h('div',[h('a',{
								style: {
									textDecoration :'underline',
									color: "#B176C5",
									fontSize: "0.13rem"
								},
								on: {
									click: () => {
										this.goMergeOrders(params.row)
									}
								}
							},no)])
						}
						return null
					}
				},
				{
					key: "OrderStatus",
					// width: 300,
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "订单状态"),
							h("div", null, "Order Status")
						]);
					},
					render: (h, params) => {
						let titles = this.typePlay(params.row).split('<br>').map(title=>h("div", null, title));
						var text = "";
						var textEn = "";
						if (
							params.row.Channel == "Wechat" &&
							(params.row.OrderStatus == "UnPay" ||
								params.row.OrderStatus == "Paying")
						) {
							text += "需在微信端继续付款";
							textEn += "payment should be continued in Wechat";
						}
						return h("div", [
							titles,
							h("p", null, text),
							h("b", null, textEn)
						]);
					}
				},{
				  	key: "OrderNo",
				  	renderHeader: (h, index) => {
				  	  	return h("div", [
				  	    	h("div", null, "退换货单号"),
				  	    	h("div", null, "ApplyNo")
				  	  	]);
				  	},
				  	render: (h, params) => {
				  	  	let props = {
				  	  	  	style: {
				  	  	  	  	display: "block",
				  	  	  	  	color: "#B176C5",
				  	  	  	  	fontSize: "0.13rem",
				  	  	  	  	cursor: "pointer"
				  	  	  	},
				  	  	  	on: {
				  	  	  	  	click: () => {
				  	  	  	  	  	this.showLogistics(params.row);
				  	  	  	  	}
				  	  	  	}
				  	  	};
				  	  	let btnList = [h('a', props, params.row.ApplyNo || '')];
				  	  	return h("div", btnList);
				  	}
				},{
					key: "OrderNo",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "退换货类型"),
							h("div", null, "returnType")
						]);
					},
					render: (h, params) => {
						let returnTypeText = params.row.returnTypeCode;
						return h("div", [
							h("div", null, returnTypeText),
						]);
					}
				},{
                    key: 'action',
                    width: 150,
                    align: 'center',
                    renderHeader:(h,index)=>{
                    	return h('div',[
                    		h('div',null,'换货'),h('div',null,'Exchange')])
                    },
                    render: (h, params) => {
                    	let titles = this.exchangeTitle(params.row.orderReplaceStatus).split('<br>').map((title,index)=>h("div", {
                    		style:{
                    			fontSize:index == 0 ? '14px':'12px'
                    		},
                    	}, title))
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled:this.disabledExchange(params.row)
                                },
                                style: {
                                	width:'130px',
                                	lineHeight:1.2,
                                    height:'40px',
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                    	this.exchangeSales(params.row)
                                    }
                                }
                            }, titles)
                        ]);
                    }
                },{
                    key: 'action',
                    width: 165,
                    align: 'center',
                    renderHeader:(h,index)=>{
                    	return h('div',[
                    		h('div',null,'退货'),h('div',null,'Returned Purchase')])
                    },
                    render: (h, params) => {
                    	let titles = this.returnTitle(params.row.orderCancelStatus).split('<br>').map((title,index)=>h("div", {
                    		style:{
                    			fontSize:index == 0 ? '14px':'12px'
                    		},
                    	}, title))
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled:this.disabledReturn(params.row)
                                },
                                style: {
                                	width:'140px',
                                    marginRight: '5px',
                                    lineHeight:1.2,
                                    height:'40px',
                                },
                                on: {
                                    click: () => {
                                    	this.returnSales(params.row)
                                    }
                                }
                            },titles)
                        ]);
                    }
                },

				{
					key: "action",
					width: 200,
					align: "center",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "操作"),
							h("div", null, "Operation")
						]);
					},
					render: (h, params) => {
						var model = params.row;
						var btnList = [];
						if (this.canRepay(model)) {
							let props = {
								style: {
									marginRight: "5px",
									color: "#B176C5",
									fontSize: "0.13rem"
								},
								on: {
									click: () => {
										this.gotoPay(
											params.row
										);
									}
								}
							}
							let payBtn = h('div',{style:{lineHeight: 1.2,margin: "5px 0 10px 0"}},[h('div',props,'继续付款'),h('div',props,'Continue to pay')])
							btnList.push(payBtn)

							let props2 = {
								style: {
									marginRight: "5px",
									cursor:'pointer',
									color: "#B176C5",
									fontSize: "0.13rem"
								},
								on: {
									click: () => {
										this.qxpay(params.row.OrderNo);
									}
								}
							}
							let cancelBtn = h('div',{style:{lineHeight: 1.2,margin: "10px 0 5px 0"}},[h('div',props2,'取消订单'),h('div',props2,'Cancel Order')])
							btnList.push(cancelBtn)
						}
						let cancelable = this.canCancelPaid(model)
						if (cancelable) {
							btnList.push(h("a",{
								props: {
									type: "text",
									size: "small"
								},
								style: {
									marginRight: "5px",
									color: "#B176C5",
									fontSize: "0.13rem"
								},
								on: {
									click: () => {
										this.cancelOrder(params.row)
									}
								}},"取消订单(Cancel Order)")
							);
						}
						
						return h("div", btnList);
					}
				},
				{
					key:'detail',
					renderHeader:(h,index)=>{
                    	return h('div',[
                    		h('div',null,'明细'),h('div',null,'Detail')])
                    },
                    render: (h, params) => {
                    	let props = {
                    		style: {
                    			display: "block",
                    			color: "#B176C5",
                    			fontSize: "0.13rem"
                    		},
                    		on: {
                    			click: () => {
                    				this.show(params.row);
	                    		}
	                    	}
	                    }

                    	let btnList = [h('a',props,'明细'),h('a',props,'Detailed')];
						return h("div", btnList);
                    }


				}
			],
			columns:[],
			orders: [],
			total: 0,
			currentPage: 1,
			page: 0,
			nextBtn: false,
			tipForPay:'',
			tipForMerge:'',
			selectOrders:[],
			UnPayCount: 0,
		};
	},
	created() {
		this.$nextTick(function() {
			this.getTipDetailAction('Tips_Product_Merge_Pay').then(res=>{
				this.tipForPay = res.ExtStr1
                this.tipForMerge = res.Content
                this.showMerge = this.timeComparison(res.ValidFrom,res.ValidTo)
			})
			let columns = [...this.o_columns]
			columns.splice(6, 2)
			this.columns = columns
			if(this.$route.query&&this.$route.query.from=='merge'){
                 this.filterMergeOrders();
            }
			if(this.$route.query&&this.$route.query.type) {
				this.paymentStatus = this.$route.query.type;
			}
			this.initData();
		  
		});
	},
	mounted() {},
	watch: {
		reload(cur) {
			if (cur) {
				this.initData();
				this.reload = false;
			}
		},
		paymentStatus(cur){
			this.orders = []
			this.reloadOrders(cur);
			this.selectOrders = []
			if (cur == 'Pay') {
				let columns = [...this.o_columns]
				columns.splice(6, 2)
				this.columns = columns
			} else if (cur == 'UnPay') {
				let columns = [...this.o_columns]
				columns.splice(6, 4)
				this.columns = columns
			} else if(cur == 'Return') {
				let columns = [...this.o_columns]
				columns.splice(4, 1);
				columns.splice(7, 4);
				this.columns = columns
			} else if(cur == '-2') {
				let columns = [...this.o_columns]
				columns.splice(4, 3)
				this.columns = [{type: 'selection',width: 60,align: 'center',},...columns]
			} else {
				this.columns = this.o_columns
			}
		},
	},
	mixins: [],
	components: {
		TopBar,
		omsOrders,
	},
	computed: {
		...mapGetters(["bogo_switch_tip", "getAccessToken",'getUserId', "getVipNo",]),
		...mapState({
			userInfo: state => state.common.wechatUserInfo,
			token: state => state.common.userToken,
		}),
		screenW() {
			return document.body.clientWidth;
		},
		hasMergingOrders(){
			return this.orders.some(item=>((item.VirtualFlag == 1 || item.VirtualFlag == 2)&&item.OrderStatus == 'Pay'))
		},
	},
	methods: {
		...mapMutations(["SAVE_ORDER", "SET_ORDERNN"]),
		...mapActions([
			"getWXOrdersAction",
			"getOrderEncryptionAction",
			"getOrderUserInfoAction",
			'cancelHistoryOrderAction',
			'getTipDetailAction',
			'getRightTopNumAction'
		]),
		timeComparison(str, str1) {
			var valid_from = !str ? null : util.formatDate.dateFromStr(str);
			var valid_to = !str1 ? null : util.formatDate.dateFromStr(str1);
			var now = new Date();
			return (
				(valid_from <= now || !valid_from) &&
				(valid_to >= now || !valid_to)
			);
		},
		filterMergeOrders(){
			this.paymentStatus = this.paymentStatus == '-2' ? 'Pay':'-2'
		},
		selection(sel){
			this.selectOrders = sel
		},
		async goMergeOrders(order){
			let no = order && 'confirm,express'.indexOf(order.OrderStatus.toLowerCase()) != -1 ? order.MergeOrderNo:undefined
			this.$router.push({
				path:'/order/mergeorders',
				query:{
					no,
					checks:this.selectOrders.map(item=>item.OrderNo).join('~')
				}
			})
		},
		exchangeSales(order){
			location = `${cvoUrl}/vo/index.html#/orders/exchange?orderNo=${order.OrderNo}-${order.OrderNo}&channel=${order.Channel}&token=${this.token}&type=${this.paymentStatus}&ApplyNo=${order.ApplyNo}`
		},
		returnSales(order){
			location = `${cvoUrl}/vo/index.html#/orders/refunds?orderNo=${order.OrderNo}-${order.OrderNo}&channel=${order.Channel}&token=${this.token}&type=${this.paymentStatus}&ApplyNo=${order.ApplyNo}`
		},
		canRepay(model) {
			return (model.OrderStatus == "UnPay" || model.OrderStatus == "Paying") && (model.OptVipNo == null || model.OptVipNo == vipNo) && (model.Channel == "MyO"||model.Channel == "Manual")
		},
		canCancelPaid(model) {
			let now = new Date()
			let paytime = Date.fromStr(model.Paytime)
			let cancelable = model.DeliveryStoreId == '501' 
							&& (this.paymentStatus == 'Pay' || this.paymentStatus == '-2') 
							&& model.OrderStatus != 'Disable' &&  model.OrderStatus != 'Disabling'
							&& ((model.VirtualFlag == 1 || model.VirtualFlag == 2) ? 'Confirm,Express'.indexOf(model.OrderStatus) == -1:true) //合并发货订单,合并后不能取消
							&& model.VirtualFlag != 10  //虚拟运费
							&& model.VirtualFlag != 20  //HWG补赠品订单
							&& now - paytime < 1800000
			return cancelable
		},
		disabledExchange(order){
			let now = new Date()
			let payTime = Date.fromStr(order.Paytime)
			return order.orderReplaceStatus == 6 || 'Express,Returned'.indexOf(order.OrderStatus) == -1 || order.Channel.toLowerCase() == 'oms' || now - payTime <= 1800000 || order.DeliveryStoreId != '501'
		},
		disabledReturn(order){
			let now = new Date()
			let payTime = Date.fromStr(order.Paytime)
			return order.orderCancelStatus == 6 || 'Express,Returning'.indexOf(order.OrderStatus) == -1 || order.Channel.toLowerCase() == 'oms' || now - payTime < 1800000 || order.DeliveryStoreId != '501'
		},
		exchangeTitle(status){ //orderReplaceStatus
			switch(parseInt(status)){
				case 1:
					return '申请换货<br>Apply for exchange'
				case 2:
					return '申请中<br>Applying'
				case 3:
					return '已申请<br>Exchange applied'
				case 4:
					return '处理中<br>Processing'
				case 5:
					return '已换货<br>Exchange completed'
				case 6:
				default:
					return '不能换货<br>No exchanging now'
			}
		},
		returnTitle(status){ //orderCancelStatus
			switch(parseInt(status)){
				case 1:
					return '退货申请<br>Return application'
				case 2:
					return '申请中<br>Applying'
				case 3:
					return '已申请<br>Has been applying'
				case 4:
					return '处理中<br>Processing'
				case 5:
					return '退货完成<br>Returns completed'
				case 6:
				default:
					return '不能退货<br>Cannot return'

			}
		},
		qxpay(OrderNo) {
			this.$Modal.confirm({
				title: "取消订单",
				content: "确定要取消订单吗？",
				onOk: () => {
					api_methods
						.CancelOrder(
							this.getAccessToken,
							this.getUserId,
							OrderNo
						)
						.then(result => {
							if (
								result &&
								result.data &&
								result.data.value == 1
							) {
								this.$Message.success('订单取消成功')
								this.initData()
							} else {
								this.$Modal.info({
									title: "信息",
									content: "订单取消失败"
								});
							}
						});
				}
			});
		},
		cancelOrder(order) {
			this.$Modal.confirm({
                title: '确认取消？',
                cancelText:'不取消',
                content: `<p>确认取消订单：${order.OrderNo}</p><p>取消成功后，订单款项、使用点数、积分及优惠券等1个工作日左右原路退回支付账户</p>`,
                onOk:async () => {
                	let date = Date.fromStr(order.Paytime)
                	let now = new Date()
                	if (now - date > 1800000) {
                		this.$Message.error('已经超出取消时间，请收到货后走退货流程')
                	} else {
                    	let response = await this.cancelHistoryOrderAction(order.OrderNo)
                    	if (response.isOK) {
                    		this.$Message.success('订单取消处理中，请稍后查看')
                    		this.initData()
                    	}else {
                    		this.$Message.error('订单处理中，请稍后重试')
                    	}
                	}
                	
                },
                onCancel: () => {
                    
                }
            });
		},
		forOrder(item) {
			if (item.OptVipNo == this.getVipNo) {
				//帮别人下单
				return "协助顾客订购:" + this.passwordName(item.Name);
			}
			if (item.VipNo == this.getVipNo) {
				//别人帮我下单
				return this.passwordName(item.OptName) + "（协助下单）";
			}
		},
		formatNoticeDate(date) {
			if (date && date != "") {
				return util.formatDate.format(date);
			}
			return "";
		},
		passwordName(name) {
			var newName = "";
			if (name) {
				if (name.length > 2) {
					newName =
						name.charAt(0) + "*" + name.charAt(name.length - 1);
				} else {
					newName = name.charAt(0) + "*";
				}
			}
			return newName;
		},
		typePlay(item) {
			const OrderStatus = {
				"UnPay":"未付款<br>UnPay",
				"Pay":"已付款<br>Paid",
				"Paying":"付款中<br>Paying",
				"Cancel":"已取消<br>Cancelled",
				"Close":"已取消",
				"Confirm":"已付款<br>Paid",
				"Oubound":"完成<br>Order paid",
				"Express":"已发货<br>Delivered",
				"PickUpEnd":"已完成<br>Completed",
				"Sign":"签收<br>Delivery signed",
				"Complete":"完成<br>Order paid",
				"Returning":"退货中<br>Returning",
				"Returned":"退货完成<br>Returned",
				"Disable":"已作废<br>Cancelled",
				"Disabling":'作废处理中<br>Cancel in processing',
			}
			if (item.VirtualFlag == 1 || item.VirtualFlag == 2) {
				if (item.OrderStatus == 'Pay') {
					return '待合并发货<br>To be consolidated and shipped'
				} else if ('Confirm,Express'.indexOf(item.OrderStatus) != -1 ) {
					return '已合并发货<br>Delivered with orders consolidation'
				}
			}
			return OrderStatus[item.OrderStatus] || ''
		},
		show(order) {
			this.SAVE_ORDER(order);
			this.$router.push(
				`/order/detail?orderNo=${order.OrderNo}&channel=${order.Channel}`
			);
		},
		showDetail(order) {
			this.SAVE_ORDER(order);
			this.$router.push(
				`/order/detail?orderNo=${order.OrderNo}&channel=${order.Channel}`
			);
		},
		showLogistics(order) {
			if(order.returnTypeCode.includes('换货')) {
				this.exchangeSales(order)
			} else{
				this.returnSales(order)
			}
		},
		reloadOrders(status,type) {
			this.page = 0;
			// if (status == 'All') {
			// 	this.$refs.omsOrders.reloadData()
			// } else {
				this.initData(type || 0,status)
			// }
		},
		async initData(type,orderStatus) {
			//this.fromPath=this.$from_path;
			if (!this.$from_path || this.$from_path.indexOf("lrp") == -1) {
				this.fromPath = "/order/product";
			} else {
				this.fromPath = "/lrp/lrplist";
			}
			if (!type) {
				//await this.getOrderUserInfoAction();
			}
			// if (this.paymentStatus == 'All') {
			// 	this.$refs.omsOrders.reloadData()
			// 	return
			// }
			this.loading = true;

			let beginTime = util.formatDate.format(this.search.beginTime);
			let endTime = util.formatDate.format(this.search.endTime);

			let response = await this.getWXOrdersAction({
				userid: this.userInfo.value.binding.user_id,
				beginTime,
				endTime,
				orderStatus:this.paymentStatus || "UnPay",
				id: this.page
			});
			this.loading = false;

			if (response) {
				if (response.length < 10) {
					this.nextBtn = true;
				} else {
					this.nextBtn = false;
				}
				this.orders = response;
				this.$nextTick(()=>{
					this.$refs.selection.selectAll(true);
				})
				// this.total = response.total;
			} else {
				this.nextBtn = true;
				this.orders = [];
			}
			this.getUnpayCount()
		},
		async getUnpayCount () {
			const result = await this.getRightTopNumAction() 
			if (result) {
				this.UnPayCount = result.UnPayOrder > 0 ? result.UnPayOrder : 0
			}
		},
		async loadData(type) {
			if (type == 0) {
				this.page--;
			} else {
				this.page++;
			}
			await this.initData(1);
		},
		async searchOrders() {
			this.page = 0;
			this.reloadOrders(this.paymentStatus,1)
		},
		async gotoPay({OrderNo,VirtualFlag}) {
			var res = await this.getOrderEncryptionAction(OrderNo);
			if (res) {
				this.SET_ORDERNN({ orderno: res, os: OrderNo });
				if (VirtualFlag == 10) {
					this.$router.push({
						path: "/order/payment",
						query: {
							orderno: res,
							os: OrderNo
						}
					});
				} else {
					this.$router.push("/order/confirm");
				}
				
				//location = `${ecUrl}Client/index.html#/order/confirm?token=${this.getAccessToken}&orderno=${res}&os=${OrderNo}`;
			}
		},
		back() {
			this.$router.go(-1);
		}
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.topbar {
	background-color: #f3f4f5;
	a {
		line-height: 40px;
		margin-left: 10.42vw;
		&:hover {
			color: $theme-color;
		}
	}
}
.content {
	padding-top: 10px;
	width: 80%;
	margin: auto;
	list-style: none;
	margin-bottom: 50px;
}
.search {
	margin-top: 0.5rem;
	margin-bottom: 0.2rem;
	.bogo_tips {
		@include fontSize($font-size-14);
		text-align: center;
		margin-bottom: 30px;
	}
}
.orderTable {
	margin-bottom: 0.3rem;
	//@include fontSize($font-size-16);
}
.xs-cells {
	display:none;
}
.page {
	margin: 0.2rem auto;
	text-align: center;
}
.xs-orders {
	color: #495060;
	font-size: 0.65rem;
	background-color: #fefefe;
	border: 1px solid rgba(0, 0, 0, 0.05);
	margin-bottom: 0.3rem;
}
.xs-order-item {
	margin-bottom: 0.2rem;
}
.breadcrumb {
	.goBack {
		float: right;
		margin-right: 20px;
	}
}
.tip {
	color:$theme-color;
}
.search-form {
	display:flex;
	align-items: center;
	justify-content: center;
}
@media (max-width: 768px){
	.orderTable {
		display:none;
	}
	.xs-cells {
		display:block;
		.flex-line {
			display:flex;
			justify-content: flex-end;

		}
	}
	.search-form {
		font-size: 12px !important;
	}
	.content {
		width: 95%;
	}
	
}
</style>